import React from 'react';

const formatCertificationDate = (isoDate) => {
  if (isoDate === null) {
    return '--';
  }

  const parts = isoDate.split("-");

  if (parts.length !== 3) {
    return "--";
  }

  const [year, month, day] = parts;

  return `${month}/${day}/${year}`;
}

export default function PhiusProjectDataTab({ project }) {
  return (
    <table className='project-detail-table'>
      <tbody>
        <tr>
          <td>Project Submitter</td>
          <td>{project.project_submitter_contact_name}</td>
        </tr>
        <tr>
          <td>Primary Project Reviewer</td>
          <td>{project.primary_reviewer_contact_name}</td>
        </tr>
        <tr>
          <td>Secondary Project Reviewer</td>
          <td>{project.secondary_reviewer_contact_name}</td>
        </tr>
        <tr>
          <td>Lead CPHC</td>
          <td>{project.lead_CPHC_contact_name}</td>
        </tr>
        <tr>
          <td>Secondary CPHC</td>
          <td>{project.secondary_CPHC_contact_name}</td>
        </tr>
        <tr>
          <td>CPHB (Builder)</td>
          <td>{project.CPHB_contact_name}</td>
        </tr>
        <tr>
          <td>Builder</td>
          <td>{project.builder_contact_name}</td>
        </tr>
        <tr>
          <td>Phius Certified Rater or Verifier</td>
          <td>{project?.phius_certified_rater_contact_name ? project?.phius_certified_rater_contact_name : project?.phius_certified_verifier_contact_name ? project?.phius_certified_verifier_contact_name : '--'} </td>
        </tr>
        <tr>
          <td>General Project Access</td>
          <td>{project?.general_access_contact_names?.length ? project.general_access_contact_names.join(', ') : '--'}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>{project.crm_status}</td>
        </tr>
        <tr>
          <td>Certification Contract Date</td>
          <td>
            {formatCertificationDate(
              project.certification_contract_date
            )}
          </td>
        </tr>
        <tr>
          <td>Design Certification Date</td>
          <td>
            {formatCertificationDate(
              project.design_certification_date
            )}
          </td>
        </tr>
        <tr>
          <td>Final Certification Date</td>
          <td>
            {formatCertificationDate(project.final_certification_date)}
          </td>
        </tr>
        {/* move: annual heating demand */}
        <tr>
          <td>Annual Heating Demand</td>
          <td>
            {project.annual_heating_demand}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        {/* move: annual cooling demand */}
        <tr>
          <td>Annual Cooling Demand</td>
          <td>
            {project.annual_cooling_demand}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        {/* move: peak heating load */}
        <tr>
          <td>Peak Heating Load</td>
          <td>
            {project.peak_heating_load}{' '}
            <span className='unit-label'>BTU/ft²hr</span>
          </td>
        </tr>
        {/* move: peak cooling load */}
        <tr>
          <td>Peak Cooling Load</td>
          <td>
            {project.peak_cooling_load}{' '}
            <span className='unit-label'>BTU/ft²hr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Site Energy Use Index (EUI)</td>
          <td>
            {project.site_energy_use_index_EUI}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        <tr>
          <td>Site EUI (w/ Renewables)</td>
          <td>
            {project.site_energy_use_index_w_renewables}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Source Energy (Residential)</td>
          <td>
            {Math.round(project.source_energy_residential)}{' '}
            <span className='unit-label'>kWh/person.yr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Source Energy (Res. w/ Renewables)</td>
          <td>
            {project.source_energy_residential_w_renewables}{' '}
            <span className='unit-label'>kWh/person.yr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Source Energy (non-Res)</td>
          <td>
            {project.source_energy_nonresidential}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Source Energy (Non-Res w/ Renewables)</td>
          <td>
            {project.source_energy_nonresidential_w_renewables}{' '}
            <span className='unit-label'>kBTU/ft²yr</span>
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Air-tightness (per enclosure area)</td>
          <td>{project.air_tightness_per_enclosure_area}</td>
        </tr>
        <tr>
          {/* number */}
          <td>Air-tightness (per volume)</td>
          <td>
            {project.air_tightness_per_volume}{' '}
            <span className='unit-label'>ACH₅₀</span>
          </td>
        </tr>
        <tr>
          <td>Measured Ventilation Fan Efficiency</td>
          <td>
            {project.measured_fan_efficiency}{' '}
            <span className='unit-label'>W/CFM</span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
